import { createSlice } from "@reduxjs/toolkit";
import {
  createLiabilityThunk,
  fetchLiabilitiesThunk,
  fetchSingleLiabilityThunk,
  deleteLiabilityThunk,
  addLiabilityPaymentThunk,
  deleteLiabilityPaymentThunk,
  updateLiabilityThunk
} from "./liabilities.thunk";

const initialState = {
  liabilities: [],
  selectedLiability: null,
  loading: false,
  error: null,
  success: false,
  message: "",
};

const liabilitiesSlice = createSlice({
  name: "liabilities",
  initialState,
  reducers: {
    clearLiabilityState: (state) => {
      state.error = null;
      state.success = false;
      state.message = "";
    },
    clearSelectedLiability: (state) => {
      state.selectedLiability = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLiabilityThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLiabilityThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.liabilities.unshift(action.payload.data);
        state.message = "Liability created successfully";
      })
      .addCase(createLiabilityThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateLiabilityThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateLiabilityThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateLiabilityThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchLiabilitiesThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchLiabilitiesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.liabilities = action?.payload?.data;
      })
      .addCase(fetchLiabilitiesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(fetchSingleLiabilityThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSingleLiabilityThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedLiability = action?.payload?.data;
      })
      .addCase(fetchSingleLiabilityThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteLiabilityThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteLiabilityThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.liabilities = state.liabilities.filter(
          (item) => item._id !== action.payload.id,
        );
        state.message = action.payload.message;
      })
      .addCase(deleteLiabilityThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(addLiabilityPaymentThunk.fulfilled, (state, action) => {
        const updated = action?.payload?.data;
        state.loading = false;
        state.success = true;
        state.message = action?.payload?.message;

        state.liabilities = state.liabilities.map((item) =>
          item._id === updated?._id ? updated : item,
        );

        if (state.selectedLiability?._id === updated?._id) {
          state.selectedLiability = updated;
        }
      })

      .addCase(deleteLiabilityPaymentThunk.fulfilled, (state, action) => {
        const updated = action.payload.data;
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;

        state.liabilities = state.liabilities.map((item) =>
          item._id === updated._id ? updated : item,
        );

        if (state.selectedLiability?._id === updated._id) {
          state.selectedLiability = updated;
        }
      });
  },
});

export const { clearLiabilityState, clearSelectedLiability } =
  liabilitiesSlice.actions;

export default liabilitiesSlice.reducer;
